
const initialState ={
 
}

export default (state = initialState, action) => {
  switch (action.type) {
   case "COMPLIANCE_SEARCH_DATA":
    return Object.assign({}, state, {
      complianceuserData: action.userData
   })
    case "COMPLIANCE_SEARCH_TEMPLATE":
      return Object.assign({}, state, {
        compliancetemplate: action.template
    })   
    case "COMPLIANCE_ERROR":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage
    })
    case "COMPLIANCE_MODAL_CLOSE":
      return Object.assign({}, state, {
        showerror: action.showerror
    })
    case "COMPLIANCE_SEARCH_COMPLETED":
      return Object.assign({}, state, {
        searchData: action.searchData
    })    
    case "CSAT_SEARCH_TEMPLATE_RESET":
      return Object.assign({}, state, {
        compliancetemplate: action.template
    })
    case "COMPLIANCE_COMPLETED_SCORES":
      return Object.assign({}, state, {
        ScoreCalculation: action.ScoreCalculation
    })
   default:
    return state
  }
 }

 